import React, { useEffect } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import UrlTo from '../url-to';
import { ScrollToTopOnNewPage } from '../components';
import Header from './components/header/index';
import CoursesPromocodesBanner from '../components/courses-promocodes-banner';
import Footer from '../components/common-footer/index';
import HomeScreen from './screens/home/index';
import CheckoutFlow from './screens/checkout';
import GiftCardCheckoutFlow from './screens/gift-card-checkout';
import GiftCardRedeem from './screens/gift-card-redeem';
import GiftCardActivated from './screens/gift-card-activated';
import SpecificCourseScreen from './screens/specific-course/index';
import ProfileScreen from './screens/profile/index';
import ProfileFromAppRedirect from './screens/profile-from-app-redirect';
import RouteChangeFbTracker from '../components/route-change-fb-tracker';
import WatchLesson from './screens/watch-lesson';
import GiftCardOverview from './screens/gift-card-overview';
import ResetPassword from './screens/reset-password';
import NotFound from '../404';
import Storage from '../storage';
import { loadCurrentUser } from './current-user/actions';
import './styles.scss';

const PageRoute = ({
  path,
  exact,
  component: Component,
  hideHeader = false,
  hideFooter = false,
  showPromocodeBanner = false,
  requireAuth = false,
  location,
}) => {
  if (requireAuth && Storage.authToken === null) {
    return <Redirect to={UrlTo.login({ role: 'Rider', returnUrl: location.pathname })} />;
  }
  return (
    <Route
      path={path}
      exact={exact}
      render={props => (
        <div id="digital-courses-root-container">
          {!hideHeader && <Header />}
          {showPromocodeBanner && <CoursesPromocodesBanner />}
          <div className="page-content">
            <Component {...props} />
          </div>
          {!hideFooter && <Footer />}
        </div>
      )}
    />
  );
};

const DigitalCourses = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (Storage.authToken !== null) {
      dispatch(loadCurrentUser());
    }

    const queryParams = new URLSearchParams(window.location.search);
    const promocodeParameter = queryParams.get('promocode');
    if (promocodeParameter) {
      Storage.courses.promocode = promocodeParameter;
    }
  }, []);

  return (
    <>
      <ScrollToTopOnNewPage />
      <RouteChangeFbTracker />
      <Helmet>
        <title>Ridesum digitala kurser - Lär av de bästa och nå nästa nivå!</title>
      </Helmet>
      <Switch>
        <PageRoute exact path={UrlTo.coursesHome()} component={HomeScreen} showPromocodeBanner />
        <PageRoute
          exact
          path={UrlTo.coursesSpecificCourse(':id')}
          component={SpecificCourseScreen}
          showPromocodeBanner
        />
        <PageRoute path={UrlTo.coursesCheckout(':id')} component={CheckoutFlow} showPromocodeBanner />
        <PageRoute path={UrlTo.coursesGiftCardCheckout()} component={GiftCardCheckoutFlow} />
        <PageRoute exact path={UrlTo.coursesGiftCardOverview()} component={GiftCardOverview} showPromocodeBanner />
        <PageRoute exact path={UrlTo.coursesGiftCardRedeem()} component={GiftCardRedeem} />
        <PageRoute exact path={UrlTo.coursesGiftCardActivated()} component={GiftCardActivated} />
        <PageRoute path={UrlTo.coursesWatchLesson(':courseId')} component={WatchLesson} requireAuth hideFooter />
        <PageRoute exact path={UrlTo.coursesProfile()} component={ProfileScreen} requireAuth />
        <PageRoute exact path={UrlTo.coursesProfileFromAppRedirect()} component={ProfileFromAppRedirect} />
        <PageRoute exact path={UrlTo.coursesResetPassword()} component={ResetPassword} hideHeader />
        <PageRoute component={NotFound} />
      </Switch>
    </>
  );
};

export default withRouter(DigitalCourses);
